import { SURROUND_MATERIAL_THICKNESS, type SurroundMaterialRoleThickness } from '../constants';

export type PanelRole = 'front' | 'back' | 'left' | 'right';

export const getThicknessForRole = (material: string, role: PanelRole): number => {
	const entry = SURROUND_MATERIAL_THICKNESS[material];
	if (entry === undefined) return 0;

	if (typeof entry === 'number') return entry;

	return (entry as SurroundMaterialRoleThickness)[role] ?? 0;
};

export const getDefaultThickness = (material: string): number => {
	const entry = SURROUND_MATERIAL_THICKNESS[material];
	if (entry === undefined) return 0;

	if (typeof entry === 'number') return entry;

	// For per-role materials, return the front thickness as the default
	return (entry as SurroundMaterialRoleThickness).front;
};

export const hasPerRoleThickness = (material: string): boolean => {
	const entry = SURROUND_MATERIAL_THICKNESS[material];
	return typeof entry === 'object' && entry !== null;
};
